export const ITEM_LAYOUTS_QUERY_KEY = (itemId) => ["items", itemId, "layouts"];
export const ITEM_SERVICE_QUESTIONS_QUERY_KEY = (itemId) => [
  "items",
  itemId,
  "service-question",
];
